var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.location))]),(_vm.table && _vm.table.length === 0)?_c('div',[_c('p',[_vm._v("\n      Loading...\n    ")])]):(_vm.store.data[_vm.location] && _vm.store.data[_vm.location].error === true)?_c('div',[_c('p',[_vm._v("\n      Server Error\n    ")])]):(_vm.table && _vm.table.length !== 0)?_c('div',[_c('div',[_c('BasicTableComponent',{staticStyle:{"width":"400px"},attrs:{"list":_vm.table,"tableClass":"table2excel","tableID":_vm.location,"zeroStr":0,"formatters":{
          'TIMESTAMP' : ['d', 'YYYY-MM-DD HH:mm:ss'],
          'QTY' : ['n', '0']
        },"titles":{
          'SITE ID' : 'SITE ID', 
          'TIMESTAMP' : 'TIMESTAMP', 
          'TRANSACTION ID' : 'TRANSACTION ID', 
          'GTIN' : 'GTIN', 
          'PRODUCT DISPLAY NAME' : 'PRODUCT DISPLAY NAME', 
          'TRANSACTION CODE' : 'TRANSACTION CODE', 
          'TRANSACTION TYPE' : 'TRANSACTION TYPE', 
          'QTY' : 'QTY', 
          'UNIT COST' : 'UNIT COST', 
          'UNIT PRICE' : 'UNIT PRICE', 
          'SYSTEM' : 'SYSTEM', 
          'NOTE' : 'NOTE',}}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }